export const DepositFlow = {
  OldFlow: "Old Flow",
  NewFlow: "New Flow",
};
